import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import DevExpress from 'devextreme';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { dxButtonOptions } from 'devextreme/ui/button';
import { alert } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { FirRemoto, Soggetto } from '../../components/popup-gestione-fir-digitali/interfaces';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { Utenteservice } from '../../services/utente.service';
import { FIR, FirStore, Pager, PostFirDigitale, Sede, SelectData, StatiFirDigitaliEnum } from './interfaces';
import { FirDigitaliTransactionService, TransactionStateMap } from '../../services/fir-digitali-transaction.service';
import { takeUntil } from 'rxjs/operators';
import { FileRentriResponse } from '../../components/popup-gestione-fir-digitali/popup-gestione-fir-digitali.component';
import { UtilityService } from '../../services/utility.service';
import { v1 as uuidv1 } from 'uuid';


@Component({
  selector: 'app-gestione-formulari',
  templateUrl: './gestione-formulari.component.html',
  styleUrls: ['./gestione-formulari.component.css'],
})
export class GestioneFormulariComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('tabella', { static: false }) tabella!: DxDataGridComponent;
  soggettoSelected: number | null = null;
  tipoSelected = 1;

  filtriAvanzati: { local: Record<string, any>, remote: Record<string, any> } = {
    local: {},
    remote: {}
  };

  dataSource: Array<Record<string, any>> = [];
  searchText = '';
  columns: Array<DevExpress.ui.dxDataGridColumn | string> = [];

  selectData: SelectData = {
    soggetto: [],
    produttore: [],
    destinatario: [],
    trasportatore: [],
    blocco_fir: [],
    autisti: [],
    targhe: [],
    tipo: [
      { valueExpr: 1, displayExpr: 'Non ancora inviati', },
      { valueExpr: 2, displayExpr: 'Inviati (anche da terzi)', },
    ],
    azienda: this.createDataSource('soggetto', 'id', 'ragioneSociale', "NostreAziende=S"),
    eer: this.createDataSource('cer', 'id', 'id', "$filter=(not endswith(id,'00'))"),
  }

  pager: Pager = {
    isStartPage: true,
    isEndPage: true,
    totalCount: 0,
    pageSize: 18,
    totalPages: 1,
    pages: [1],
    pageIndex: 1,
  };
  skip: number = 0;

  searchBtn: dxButtonOptions = {
    icon: 'find',
    stylingMode: 'text',
    onClick: async () => {
      await this.search();
    },
  };
  statiRemoti: Array<{ key: string, value: string }> = [];
  displayAutista = (item) => item ? `${item.nome} ${item.cognome} ( ${item.matricola} )` : '';
  displayBlocco = (item) => item ? `( ${item.codiceBlocco} ) ${item.descrizione}` : '';
  annoSelected: string
  private readonly KEY_STORE = 'fir_digitali_store'
  private readonly $destroy: Subject<void> = new Subject()
  constructor(
    private readonly ComponentService: ComponentService,
    private readonly Utenteservice: Utenteservice,
    private readonly Apiservice: Apiservice,
    private readonly Cdr: ChangeDetectorRef,
    private readonly loader: NgxSpinnerService,
    private readonly forms: FormsTemplateService,
    private readonly UtilityService: UtilityService,
    private readonly FirTransaction: FirDigitaliTransactionService
  ) {
    const store = this.getSessionStorage()
    if (store) {
      Object.keys(store).forEach((key) => {
        switch (key) {
          case 'filtriAvanzati':
            this.filtriAvanzati = store.filtriAvanzati
            break
          case 'soggetto':
            this.soggettoSelected = store.soggetto
            break
          case 'filtro':
            this.searchText = store.filtro
            break
          case 'tipo':
            this.tipoSelected = store.tipo
            break
          default:
            break
        }
      })
      // this.doCall(this.soggettoSelected);
    }
  }
  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }

  ngOnInit(): void {
    this.annoSelected = `Anno ${this.Utenteservice.InfoUtenteConnesso.annoSelected}`
    this.statiRemoti = Object.keys(StatiFirDigitaliEnum)
      .filter(k => isNaN(Number(k)))
      .map(k => ({
        key: k,
        value: this.splitCamelCase(StatiFirDigitaliEnum[k])
      }));

    this.FirTransaction.state$.pipe(takeUntil(this.$destroy)).subscribe({
      next: async (next: TransactionStateMap) => {
        console.log('state', next)
        Object.keys(next).forEach(async (key) => {
          if (next[key].status === 'completed' && next[key].lastTask === 'InvioFirDigitale') if (this.tabella) {
            await this.sincronizza()
            await this.doCall(this.soggettoSelected)
            await this.tabella.instance.refresh();
          };
          if (next[key].status === 'error' && next[key].lastTask === 'InvioFirDigitale') if (this.tabella) {
            await this.sincronizza()
            await this.doCall(this.soggettoSelected)
            await this.tabella.instance.refresh();
          };
          if (next[key].listTask.every((val) => val.status === 'completed')) if (this.tabella) {
            await this.doCall(this.soggettoSelected)
            await this.tabella.instance.refresh();
          };
        })
      },
    })
    this.FirTransaction.isProcessing$.pipe(takeUntil(this.$destroy)).subscribe({
      next: (next) => {
        console.log('isProcessing', next)
      },
      error: (err) => {
        console.error(err)
      },
    })
    this.FirTransaction.currentTask$.pipe(takeUntil(this.$destroy)).subscribe({
      next: (next) => {
        console.log('currentTask', next)
      },
      error: (err) => {
        console.error(err)
      },
    })
  }

  ngAfterViewInit(): void {
    this.constructColumns();
  }

  checkFir(nFir: string) {
    const state = this.FirTransaction.getFirState(nFir)
    if (!state) return false
    return state.status !== 'completed' && state.status !== 'error'
  }
  onRowClick(event: any): void {
    if (this.tabella.instance) {
      this.tabella.instance.selectRowsByIndexes([event.dataIndex]);
    }
  }

  async resetFiltriAvanzati(): Promise<void> {
    const tipo = this.tipoSelected === 1 ? 'local' : 'remote'
    this.filtriAvanzati[tipo] = {}
    this.processSessionStorage({ filtriAvanzati: this.filtriAvanzati })
    await this.doCall(this.soggettoSelected);
  }

  async onValueChangedSelectData(event, type: 'local' | 'remote', key: string) {
    if (!event || event.value === undefined) return;
    else if (event.value === null) delete this.filtriAvanzati[type][key];
    else if (Array.isArray(event.value) && event.value.length === 0) delete this.filtriAvanzati[type][key];
    else this.filtriAvanzati[type][key] = event.value;
    this.processSessionStorage({ filtriAvanzati: this.filtriAvanzati })
    this.resetPager()
    if (this.soggettoSelected) await this.doCall(this.soggettoSelected);
  }

  splitCamelCase(str: any): string {
    if (!str) return '';
    str = String(str);
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/([0-9])([A-Za-z])/g, '$1 $2')
      .replace(/([A-Za-z])([0-9])/g, '$1 $2')
      .trim();
  }

  async sincronizza() {
    if (!this.soggettoSelected) return
    this.loader.show()
    try {
      await this.Apiservice.PutApi(`DocumentoRifiuti/SincronizzaFirDigitaliRentri?idSoggetto=${this.soggettoSelected}`, {})
      await this.doCall(this.soggettoSelected)
      if (this.tabella) this.tabella.instance.refresh()
    } catch (err) {
      console.error(err)
    } finally {
      this.loader.hide()
    }
  }

  async onValueChangedMaster(event, id: string) {
    if (id === 'azienda') {
      this.soggettoSelected = event.value;
      this.processSessionStorage({ soggetto: event.value })
      this.resetPager();
      await this.doCall(this.soggettoSelected);
      this.Cdr.detectChanges()
      this.refreshSelectFilter(event.value)
    }

    if (id === 'tipologia') {
      this.tipoSelected = event.value;
      this.processSessionStorage({ tipo: event.value })
      this.resetPager();
      // this.searchText = '';
      await this.doCall(this.soggettoSelected);
      this.constructColumns();
      this.Cdr.detectChanges()
      this.refreshSelectFilter(this.soggettoSelected)
    }
  }

  async sendFir(event: any, row: any): Promise<void> {
    console.log('sendFir', event, row);
    this.loader.show()
    try {
      if (!row.data) throw new Error
      const data = await this.Apiservice.GetApi(`DocumentoRifiuti/${row.data.id}`) as FIR
      if (!data) throw new Error
      const { produttore, trasportatore } = await this.chechkNS(data)
      if (produttore && trasportatore) {
        const guid = Math.random().toString().replace("0.", "")
        const instanceData = {
          isPopUp: true,
          remoteOperation: false,
          api: "",
          service: "SelezioneNsAzienda",
          filterKey: "",
          type: "simple",
          standardBtnBottom: [22, 16]
        }
        this.ComponentService.setNewPopUp(guid, 'NewNicaFormComponent', null, '400', null, instanceData, false, true, 'Selezione Proprio Impianto')
        const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (event) => {
          console.log(event)
          if (event && event.guid === guid) {
            if (event.name === "return") {
              this.ComponentService.destroyCurrentOpenPopUpByGuid(guid)
              sub.unsubscribe()
            }
            if (event.name === "submitFormStatic") {
              const outData = event.data
              if (outData && outData.emettitore) {
                let key: 'idProduttore' | 'idTrasportatore' | undefined
                switch (outData.emettitore) {
                  case 'P':
                    key = 'idProduttore'
                    break
                  case 'T':
                    key = 'idTrasportatore'
                    break
                  default:
                    break;
                }
                if (!key) throw new Error
                await this.sendDataToRentri(data, key)
              }
              this.ComponentService.destroyCurrentOpenPopUpByGuid(guid)
              sub.unsubscribe()
            }
          }
        })
      } else if (produttore && !trasportatore) {
        await this.sendDataToRentri(data, 'idProduttore')
      } else if (trasportatore && !produttore) {
        await this.sendDataToRentri(data, 'idTrasportatore')
      }
    } catch (err) {
      console.error(err)
    } finally { this.loader.hide() }
  }

  async search(): Promise<void> {
    this.processSessionStorage({ filtro: this.searchText })
    this.resetPager()
    await this.doCall(this.soggettoSelected);
    this.Cdr.detectChanges()
  }

  async goToPage(pageIndex: number): Promise<void> {
    if (pageIndex < 1 || pageIndex > this.pager.totalPages) return;

    this.pager.pageIndex = pageIndex;
    if (this.tipoSelected === 1) this.skip = (this.pager.pageIndex - 1) * this.pager.pageSize;
    else if (this.tipoSelected === 2) this.skip = pageIndex
    await this.doCall(this.soggettoSelected);
  }

  async chechkNS(data: FIR): Promise<{ produttore: boolean, trasportatore: boolean } | null> {
    if (!data || !data.produttore_Id_Soggetto || !data.trasportatore_Id_Soggetto) return null
    const prod = await this.Apiservice.GetApi(`soggetto/${data.produttore_Id_Soggetto}`) as Record<any, string>
    const trans = await this.Apiservice.GetApi(`soggetto/${data.trasportatore_Id_Soggetto}`) as Record<any, string>
    return {
      produttore: prod ? Boolean(prod.nsAzienda) : false,
      trasportatore: trans ? Boolean(trans.nsAzienda) : false
    }
  }

  async gestisciFirRemoto(event, row) {
    console.log('gestisciFirRemoto', event, row);
    if (!row || !row.data || !row.data.numero_fir) return;
    const numero_fir = row.data.numero_fir
    if (!numero_fir) return;
    this.loader.show()
    try {
      const soggetto = await this.Apiservice.GetApi(`soggetto/${this.soggettoSelected}`) as Record<any, string>
      const firRemoto: FirRemoto = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}?idSoggetto=${this.soggettoSelected}`) as FirRemoto
      const identificativo_soggetto = soggetto.codiceFiscale
      const operazioniDisponibili = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}/GetOperazioniDisponibili?idSoggetto=${this.soggettoSelected}&identificativo_soggetto=${identificativo_soggetto}`)
      console.log(operazioniDisponibili)
      const guid = uuidv1()
      const instanceData = {
        operazioniDisponibili,
        firRemoto,
        soggetto,
        guid,
      }
      this.ComponentService.setNewPopUp(guid, 'PopupGestioneFirDigitaliComponent', null, '-webkit-fill-available', null, instanceData, false, true, `Gestione FIR ${numero_fir}`, 'top')
      const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (out) => {
        if (out && out.guid === guid) {
          console.log('PopupGestioneFirDigitaliComponent', out)
          if (out.name === "closePopup") {
            await this.doCall(this.soggettoSelected)
            await this.tabella.instance.refresh()
            sub.unsubscribe()
          }
        }
      })
    } catch (err) {
      console.log(err)
    } finally {
      this.loader.hide()
    }
  }
  async downloadXfir(event, row) {
    if (!row || !row.data || !row.data.numero_fir) return;
    const numero_fir = row.data.numero_fir
    if (!numero_fir) return;
    this.loader.show()
    try {
      const xfir = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}/xfir?idSoggetto=${this.soggettoSelected}`) as FileRentriResponse
      const base64DataUrl = `data:${xfir.mime};base64,${xfir.content}`;
      const file = this.UtilityService.base64ToFileObj(
        base64DataUrl,
        xfir.nome_file.split('.')[0] + '.zip'
      );
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = xfir.nome_file.split('.')[0] + '.zip';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.log(err)
    } finally {
      this.loader.hide()
    }
  }
  buildAdvancedFilter(): string {
    const filter = []
    if (this.tipoSelected === 1) {
      // OData
      if (Object.keys(this.filtriAvanzati.local).length > 0) {
        const arr = Object.entries(this.filtriAvanzati.local)
        if (arr.length > 0) {
          arr.forEach(([key, value]) => {
            if (value) {
              switch (key) {
                case 'daData':
                  filter.push(`(dataRegistrazione ge ${value})`)
                  break;
                case 'aData':
                  filter.push(`(dataRegistrazione le ${value})`)
                  break;
                case 'bloccoFIR':
                  filter.push(`(startswith(numeroFormulario,'${value}'))`)
                  break;
                case 'produttore':
                  filter.push(`(idProduttore eq ${value})`)
                  break;
                case 'trasportatore':
                  filter.push(`(idTrasportatore eq ${value})`)
                  break;
                case 'destinatario':
                  filter.push(`(idDestinatario eq ${value})`)
                  break;
                case 'eer':
                  filter.push(`(eer eq '${value}')`)
                  break;
                case 'autista':
                  filter.push(`(idAutista eq ${value})`)
                  break;
                case 'targa':
                  filter.push(`(automezzo_Targa eq '${value}')`)
                  break;
                default:
                  break;
              }
            }
          })
        }
      }
      return filter.join(' and ');
    }
    if (this.tipoSelected === 2) {
      // query
      if (Object.keys(this.filtriAvanzati.remote).length > 0) {
        const arr = Object.entries(this.filtriAvanzati.remote)
        if (arr.length > 0) {
          arr.forEach(([key, value]) => {
            switch (key) {
              case 'stato':
                if (Array.isArray(value)) value.forEach((val) => filter.push(`stati=${val}`))
                break;
              case 'daData':
                filter.push(`data_creazione_da=${value}`)
                break;
              case 'aData':
                filter.push(`data_creazione_a=${value}`)
                break;
              case 'soggetto':
                filter.push(`num_iscr_sito=${value}`)
                break;
              case 'eer':
                filter.push(`codice_eer=${value}`)
                break;
              case 'bloccoFIR':
                filter.push(`codice_blocco=${value}`)
                break;
              default:
                break;
            }
          })
        }
      }
      return filter.join('&');
    }

  }
  async apriDevice() {
    const guid = Math.random().toString().replace("0.", "")
    const soggetto = await this.Apiservice.GetApi(`soggetto/${this.soggettoSelected}`) as Soggetto
    if (!soggetto) return alert('Errore nel recupero del soggetto. Riprovare', 'Attenzione');
    const instanceData = {
      soggetto
    }
    this.ComponentService.setNewPopUp(guid, 'GestioneDispositiviComponent', null, '-webkit-fill-available', null, instanceData, false, true, `Gestione Dispositivi ${soggetto.ragioneSociale}`, 'top')
    const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (out) => {
      if (out && out.guid === guid) {
        console.log('GestioneDispositiviComponent', out)

      }
    })
  }
  //!----------------------------------------------------------------------------------------------------------------

  private async sendDataToRentri(fir: FIR, key: 'idProduttore' | 'idTrasportatore') {
    this.loader.show()
    try {
      const emettitore = await this.Apiservice.GetApi(`sede?id=${fir[key]}`) as Sede

      const produttore = key === 'idProduttore' ? emettitore : await this.Apiservice.GetApi(`sede?id=${fir.idProduttore}`) as Sede

      const trasportatoriList = await this.Apiservice.GetApi(`sede/${fir.trasportatore_Id_Soggetto}`) as Array<Sede>
      const trasportatore: Sede | null = key === 'idTrasportatore' ? emettitore : trasportatoriList.filter((val) => val.id === fir.idTrasportatore)[0] || null

      const vettori: { id: string, descrizione: string }[] = await this.Apiservice.GetApi(`TipoTrasporto`) as { id: string, descrizione: string }[]
      const tipoAnalisiList: { id: string, descrizione: string }[] = this.forms.getDati('tipoAnalisiList')

      const destinatario = await this.Apiservice.GetApi(`sede?id=${fir.idDestinatario}`) as Sede

      const intermediario = fir.idIntermediario ? await this.Apiservice.GetApi(`sede?id=${fir.idIntermediario}`) as Sede : null

      const cantiere = fir.idCantiereFuoriUl ? await this.Apiservice.GetApi(`Cantiere?id=${fir.idCantiereFuoriUl}`) as Record<any, any> : null

      if (!emettitore || !emettitore.idSedeRentri) alert('La sede presente nel FIR non è allineata la RENTRi', 'Attenzione');

      const control = this.checkCampi(fir)
      if (!control) return;
      const dataToSend: PostFirDigitale = {
        num_iscr_sito: emettitore.idSedeRentri,
        dati_partenza: {
          numero_fir: fir.numeroFormulario,
          ///* PROD
          produttore: {
            denominazione: fir.produttore_Descrizione_Soggetto,
            codice_fiscale: fir.produttore_Codice_Fiscale,
            nazione_id: produttore.stato,
            autorizzazione: fir.idAutorizzazioneProduttore ? {
              numero: fir.autorizzazioneProduttore_Numero,
              tipo: fir.autorizzazioneRentriProduttore_Codice
            } : null,
            indirizzo: {
              indirizzo: produttore.indirizzo,
              cap: produttore.cap,
              civico: produttore.civico,
              citta: {
                ...(produttore.stato === 'IT' ?
                  { comune_id: produttore.istatComune } :
                  { nazione_id: produttore.stato, nome_citta: produttore.comune }
                )
              }
            },
            detentore: fir.isDetentore,
            luogo_produzione: cantiere ? {
              cap: fir.cantiere_CAP,
              citta: {
                ...(cantiere.stato === 'IT' ?
                  { comune_id: cantiere.istat } :
                  { nazione_id: cantiere.stato, nome_citta: cantiere.comune }
                )
              },
              civico: fir.cantiere_Civico,
              indirizzo: fir.cantiere_Indirizzo
            } : null
          },
          ///* DEST
          destinatario: {
            denominazione: fir.destinatario_Descrizione_Soggetto,
            codice_fiscale: fir.destinatario_Codice_Fiscale,
            nazione_id: destinatario.stato,
            autorizzazione: fir.idAutorizzazioneDestinatario ? {
              numero: fir.autorizzazioneDestinatario_Numero,
              tipo: fir.autorizzazioneRentriDestinatario_Codice
            } : null,
            attivita: fir.idOperazioneRD,
            indirizzo: {
              indirizzo: destinatario.indirizzo,
              cap: destinatario.cap,
              civico: destinatario.civico,
              citta: {
                ...(destinatario.stato === 'IT' ?
                  { comune_id: destinatario.istatComune } :
                  { nazione_id: destinatario.stato, nome_citta: destinatario.comune }
                )
              }
            }
          },
          ///* TRANS
          trasportatori: fir.idTrasportatore ? [
            {
              denominazione: fir.trasportatore_Descrizione_Soggetto,
              codice_fiscale: fir.trasportatore_Codice_Fiscale,
              nazione_id: trasportatore.stato,
              numero_iscrizione_albo: trasportatore.numeroIscrizioneAlbo,
              tipo_trasporto: vettori.filter((vet) => vet.id === trasportatore.tipoTrasporto)[0].descrizione || null,
            },
            ...(fir.listaAltriSoggettiT && fir.listaAltriSoggettiT.length > 0 ? fir.listaAltriSoggettiT.map((trasp) => {
              if (trasp) return {
                denominazione: trasp.descrizione,
                codice_fiscale: trasp.codiceFiscale,
                nazione_id: trasp.stato,
                numero_iscrizione_albo: trasp.numeroIscrizioneAlbo,
                tipo_trasporto: vettori.filter((vet) => vet.id === trasp.tipoTrasporto)[0].descrizione || null,
              }
            }).filter((trasp) => trasp !== undefined && trasp !== null) : [])
          ] : null,
          ///* INTER
          intermediari: intermediario ? [
            {
              denominazione: fir.intermediario_Descrizione_Soggetto,
              codice_fiscale: fir.intermediario_Codice_Fiscale,
              nazione_id: intermediario.stato,
              numero_iscrizione_albo: intermediario.numeroIscrizioneAlbo
            },
            ...(fir.listaAltriSoggettiI && fir.listaAltriSoggettiI.length ? fir.listaAltriSoggettiI.map((val) => {
              if (val) return {
                denominazione: val.descrizione,
                codice_fiscale: val.codiceFiscale,
                nazione_id: val.stato,
                numero_iscrizione_albo: val.numeroIscrizioneAlbo,
              }
            }).filter((val) => val !== undefined && val !== null) : [])
          ] : null,
          ///* RIFIUT
          rifiuto: {
            codice_eer: fir.eer,
            descrizione: fir.eer.endsWith('99') ? fir.descrizioneAssegnata : null,
            provenienza: fir.isUrbano === true ? 'U' : 'S',
            caratteristiche_chimico_fisiche: fir.caratteristicheChimiche && fir.caratteristicheChimiche !== '' ? fir.caratteristicheChimiche : null,
            caratteristiche_pericolo: fir.listaHP.length > 0 ? fir.listaHP : null,
            stato_fisico: fir.statoFisico_Iniziali,
            quantita: fir.quantitaOrigineKg ? {
              unita_misura: 'kg',
              valore: fir.quantitaOrigineKg
            } : fir.volume ? {
              unita_misura: 'l',
              valore: fir.unitaMisuraVolume === 'M' ? fir.volume * 1000 : fir.volume
            } : null,
            verificato_in_partenza: fir.verificatoPartenza,
            trasporto_adr: fir.adr === 'S',
            dati_adr: fir.adr === 'S' ? {
              numero_onu: fir.idONU,
              classe: fir.idClasseAdr,
              note: fir.testoADR_Descrizione,
            } : null,
            analisi_classificazione: fir.tipoAnalisi !== '' && fir.analisiNumero !== '' && fir.analisiData ? {
              tipo: tipoAnalisiList.filter((anal) => anal.id === fir.tipoAnalisi)[0].descrizione || null,
              numero: fir.analisiNumero,
              data: fir.analisiData
            } : null,
            numero_colli: !fir.rinfusa ? fir.numeroColli ? fir.numeroColli.toString() : null : null,
            rinfusa: fir.rinfusa ? fir.rinfusa : false
          },

          trasbordo_parziale_origine: null,//# non gestito dal web
          annotazioni: fir.annotazioni !== '' ? fir.annotazioni : null
        },
        dati_trasporto_partenza: fir.dataInizioTrasporto && fir.idAutista ? {
          conducente: {
            cognome: fir.autista_Cognome,
            nome: fir.autista_Nome
          },
          targa_automezzo: fir.automezzo_Targa,
          percorso: fir.percorso,
          presa_in_carico_rimorchio_precedente: false, //# non gestito dal web
          data_ora_inizio_trasporto: fir.dataInizioTrasporto,
          targa_rimorchio: fir.rimorchio_Targa,
          annotazioni: fir.annotazioni
        } : null
      }
      console.log(dataToSend)
      await this.FirTransaction.enqueueAction({
        endpoint: `rentri/fir-digitali?idSoggetto=${this.soggettoSelected}`,
        idSoggetto: this.soggettoSelected,
        numeroFormulario: fir.numeroFormulario,
        processId: `InvioFirDigitale`,
        title: 'Invio Formulario ' + fir.numeroFormulario,
        getTransaction_id: async () => await this.Apiservice.PostApi(`rentri/fir-digitali?idSoggetto=${this.soggettoSelected}`, dataToSend) as Promise<{ transazione_id: string }>
      })

      await this.tabella.instance.refresh()
    } catch (err) {
      console.error(err)
    } finally {
      this.loader.hide()
    }
  }

  private checkCampi(fir: FIR): boolean {
    const msg = {}
    const chechkFields = [
      'autorizzazioneProduttore_Numero',
      'autorizzazioneRentriProduttore_Codice',
      'autorizzazioneDestinatario_Numero',
      'autorizzazioneRentriDestinatario_Codice',
      'idOperazioneRD'
    ]
    chechkFields.forEach((field) => {
      if (!fir[field]) {
        switch (field) {
          case 'autorizzazioneProduttore_Numero':
          case 'autorizzazioneRentriProduttore_Codice':
            msg['AutorizzazioneProduttore'] = `<p class="mb-1">Campo Autorizzazione Produttore mancante</p>`
            break;
          case 'autorizzazioneDestinatario_Numero':
          case 'autorizzazioneRentriDestinatario_Codice':
            msg['AutorizzazioneDestinatario'] = `<p class="mb-1">Campo Autorizzazione Destinatario mancante</p>`
            break;
          case 'idOperazioneRD':
            msg['idOperazioneRD'] = `<p class="mb-1">Campo Operazione Smalt/Rec. mancante</p>`
            break;
          default:
            break;
        }
      }
    })
    if (Object.keys(msg).length > 0) {
      alert(`${Object.keys(msg).map((key) => msg[key]).join('')}`, 'Attenzione')
      return false
    } else {
      return true
    }
  }

  private async doCall(idSoggetto?: number | null): Promise<void> {
    if (!idSoggetto) return;

    const searchFilter = this.processFilter();
    const filtriAvanzatiFilter = this.buildAdvancedFilter();
    this.loader.show()
    try {
      if (this.tipoSelected === 1) {
        let filter = `?$orderby=dataRegistrazione desc,id asc&$filter=((produttore_Id_Soggetto eq ${idSoggetto} or trasportatore_Id_Soggetto eq ${idSoggetto}) and (tolower(idRentri) ne 'ok' )`;
        if (searchFilter) filter += ` and (${searchFilter})`
        if (filtriAvanzatiFilter) filter += ` and (${filtriAvanzatiFilter})`
        filter += `)&$count=true&$skip=${this.skip}&$top=${this.pager.pageSize}`;
        const res: any = await this.Apiservice.GetApi(`DocumentoRifiuti${filter}`);
        this.setPager(res.totalCount || 0);
        this.dataSource = Array.isArray(res.items) ? res.items : [];
      } else if (this.tipoSelected === 2) {
        console.log(this.filtriAvanzati.remote)
        let filter = `?idSoggetto=${idSoggetto}`
        if (searchFilter) filter += `&${searchFilter}`
        if (filtriAvanzatiFilter) filter += `&${filtriAvanzatiFilter}`
        const [res, count]: any[] = await Promise.all([
          await this.Apiservice.GetApi(`rentri/fir-digitali${filter}`, {
            pageSize: this.pager.pageSize.toString(),
            pageNumber: this.pager.pageIndex.toString()
          }),
          await this.Apiservice.GetApi(`rentri/fir-digitali/Count${filter}`)
        ])
        this.setPager(count || 0);
        this.dataSource = Array.isArray(res) ? res : [];
      }
    } catch (err) {
      console.error(err)
      this.dataSource = []
    } finally {
      this.loader.hide()
    }
    if (this.tabella) {
      this.tabella.instance.refresh()
      this.tabella.instance.repaint()
    }
    this.Cdr.detectChanges()
  }

  private refreshSelectFilter(idSoggetto: number) {
    if (idSoggetto) {
      this.selectData.soggetto = this.createDataSource(`sede/${this.soggettoSelected}`, 'idSedeRentri', 'descrizione', '', 10, true, this.soggettoSelected, items => items.filter(x => x.idSedeRentri !== undefined && x.idSedeRentri !== null));
      this.selectData.produttore = this.createDataSource(`sede/${this.soggettoSelected}`, 'id', 'descrizione', '', 10, true, this.soggettoSelected, items => items.filter(x => x.isProduttore === true));
      this.selectData.destinatario = this.createDataSource(`sede/${this.soggettoSelected}`, 'id', 'descrizione', '', 10, true, this.soggettoSelected, items => items.filter(x => x.isDestinatario === true));
      this.selectData.trasportatore = this.createDataSource(`sede/${this.soggettoSelected}`, 'id', 'descrizione', '', 10, true, this.soggettoSelected, items => items.filter(x => x.isTrasportatore === true));
      this.selectData.blocco_fir = this.createDataSource(`VivifirBlocchi/GetElencoBlocchiVirtuali`, 'codiceBlocco', 'codiceBlocco', `idSoggetto=${idSoggetto}&escludiAnnullati=true&$filter=(isSpurghi eq false)`, 10, true, this.soggettoSelected)
      this.selectData.autisti = this.createDataSource(`Autista/GetAllByIdSoggetto`, 'id', ['nome', 'cognome'], `idSoggetto=${idSoggetto}&$filter=(isAutista eq true)`, 10, true, this.soggettoSelected)
      this.selectData.targhe = this.createDataSource(`Automezzo/GetAllByIdSoggetto`, 'targa', 'targa', `idSoggetto=${idSoggetto}`, 10, true, this.soggettoSelected)
    } else {
      this.selectData.soggetto = []
      this.selectData.produttore = []
      this.selectData.destinatario = []
      this.selectData.trasportatore = []
      this.selectData.blocco_fir = []
      this.selectData.autisti = []
      this.selectData.targhe = []
    }
  }

  private processFilter(): string {
    const text = this.searchText.trim();
    if (this.tabella) this.tabella.instance.searchByText(text)
    if (!text) return '';
    if (this.tipoSelected === 1) {
      // OData
      return `contains(tolower(numeroFormulario), tolower('${text}'))`;
    }
    if (this.tipoSelected === 2) {
      // query
      return `numero_fir=${text}`;
    }
    return '';
  }

  private resetPager(): void {
    const pageSize = this.pager.pageSize || 15;

    this.pager = {
      isStartPage: true,
      isEndPage: true,
      totalCount: 0,
      pageSize,
      totalPages: 1,
      pages: [1],
      pageIndex: 1,
    };
    this.skip = 0;
    if (this.tabella) {
      this.tabella.instance.refresh()
      this.tabella.instance.repaint()
      this.tabella.instance.clearSelection()
      this.tabella.instance.clearGrouping()
      this.tabella.instance.clearFilter()
      this.tabella.instance.clearSorting()
      this.tabella.instance.deselectAll()
    }
    this.Cdr.detectChanges()
  }

  private setPager(totalCount: number): void {
    this.pager.totalCount = totalCount;
    this.pager.totalPages = Math.max(1, Math.ceil(this.pager.totalCount / this.pager.pageSize));
    this.pager.pages = this.getPagerWithEllipses(this.pager.pageIndex, this.pager.totalPages, 4);
    this.pager.isStartPage = this.pager.pageIndex <= 1;
    this.pager.isEndPage = this.pager.pageIndex >= this.pager.totalPages;
    this.Cdr.detectChanges()
  }

  private createDataSource(
    endpoint: string,
    keyField: string = 'id',
    displayField: string | string[] = 'id',
    filterPart: string = '',
    pageSize: number = 10,
    isPreCheck: boolean = false,
    chechkValue?: any,
    transformFn?: (items: any[]) => any[],
  ) {
    return new DataSource({
      store: new CustomStore({
        key: keyField,
        load: async (loadOptions: any) => {
          console.log(loadOptions)
          if (isPreCheck && !chechkValue) return { data: [], totalCount: 0 };
          try {
            const skip = loadOptions.skip || 0;
            const take = loadOptions.take || pageSize;
            let currentFilterPart = '&' + filterPart.replace('?', '');
            if (loadOptions.searchValue) {
              const s = loadOptions.searchValue.trim().toLowerCase();

              if (!Array.isArray(displayField)) {
                if (currentFilterPart.includes('$filter=')) {
                  currentFilterPart = currentFilterPart.replace(
                    '$filter=',
                    `$filter=contains(tolower(${displayField}), '${s}') and `
                  );
                } else {
                  currentFilterPart += `&$filter=contains(tolower(${displayField}), '${s}')`;
                }
              } else {
                displayField.forEach((val) => {
                  if (currentFilterPart.includes('$filter=')) {
                    currentFilterPart = currentFilterPart.replace(
                      '$filter=',
                      `$filter=contains(tolower(${val}), '${s}') and `
                    );
                  } else {
                    currentFilterPart += `&$filter=contains(tolower(${val}), '${s}')`;
                  }
                })
              }
            }
            const url =
              `${endpoint}?$skip=${skip}&$top=${take}&$count=true` +
              currentFilterPart;
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return {
              data: items,
              totalCount: res.totalCount || 0,
            };
          } catch (e) {
            console.error("Errore load generic", e);
            throw e;
          }
        },

        byKey: async (key: any) => {
          if (isPreCheck && !chechkValue) return null;
          try {
            const url = (() => {
              const partKey = typeof key === 'string' ? `'${key}'` : `${key}`
              const filters: string[] = [];
              const m = filterPart.match(/\$filter=(.*)/);
              if (m) filters.push(`(${m[1]})`);
              filters.push(`${keyField} eq ${partKey}`);
              filterPart = filterPart.split('$filter=')[0].replace(/&$/, '')
              return `${endpoint}?${filterPart}&$filter=${filters.join(' and ')}`
            })();
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return items[0] || null;
          } catch (e) {
            console.error("Errore byKey generic", e);
            throw e;
          }
        },
      }),
      paginate: true,
      pageSize,
      searchExpr: displayField,
    });
  }


  private getPagerWithEllipses(
    current: number,
    total: number,
    max: number = 4
  ): (number | string)[] {
    if (total <= max + 2) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const mezzo = Math.floor(max / 2);
    let start = Math.max(2, current - mezzo);
    let end = Math.min(total - 1, current + mezzo);
    while (end - start + 1 < max) {
      if (start > 2) start--;
      else if (end < total - 1) end++;
      else break;
    }
    const pages: (number | string)[] = [1];
    if (start > 2) pages.push('...');
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < total - 1) pages.push('...');
    pages.push(total);
    return pages;
  }

  private constructColumns(): void {
    if (this.tipoSelected === 1) {
      this.columns = [
        {
          dataField: 'invia',
          caption: '',
          width: 90,
          alignment: 'center',
          cellTemplate: 'btnInviaCellTemplate',
          allowSorting: false,
          dataType: 'string'
        },
        {
          dataField: 'idRentri',
          caption: 'Stato',
          dataType: 'string',
          width: 120,
          allowSorting: false,
          cellTemplate: (container, options) => container.append(!options.value ? 'Non Inviato' : 'Da Sincronizzare')
        },
        {
          dataField: 'dataRegistrazione',
          caption: 'Data',
          dataType: 'date',
          width: 90,
          alignment: 'center',
          allowSorting: false,
        },
        {
          dataField: 'numeroFormulario',
          caption: 'Numero Fir',
          dataType: 'string',
          width: 130,
          allowSorting: false,
        },
        {
          dataField: 'produttore_Descrizione_Soggetto',
          caption: 'Produttore',
          dataType: 'string',
          allowSorting: false,
        },
        {
          dataField: 'trasportatore_Descrizione_Soggetto',
          caption: 'Trasportatore',
          dataType: 'string',
          allowSorting: false,
        },
        {
          dataField: 'destinatario_Descrizione_Soggetto',
          caption: 'Destinatario',
          dataType: 'string',
          allowSorting: false,
        },
        {
          dataField: 'eer',
          caption: 'EER',
          dataType: 'string',
          alignment: 'center',
          width: 90,
          allowSorting: false,
        },
        {
          dataField: 'quantitaOrigineKg',
          caption: 'Quantità',
          dataType: 'string',
          alignment: 'center',
          width: 90,
          allowSorting: false,
        },
      ];
    } else if (this.tipoSelected === 2) {
      this.columns = [
        {
          dataField: 'gestione',
          caption: '',
          width: 90,
          alignment: 'center',
          cellTemplate: 'btnGestioneCellTemplate',
          allowSorting: false,
          dataType: 'string'
        },
        {
          dataField: 'download',
          caption: '',
          width: 36,
          alignment: 'center',
          cellTemplate: 'btnDownloadXfirTemplate',
          allowSorting: false,
          dataType: 'string'
        },
        {
          dataField: 'list',
          caption: '',
          width: 36,
          alignment: 'center',
          cellTemplate: 'btnListaAllegati',
          allowSorting: false,
          dataType: 'string'
        },
        {
          dataField: 'stato',
          caption: 'Stato',
          dataType: 'string',
          width: 270,
          allowSorting: false,
          cellTemplate: (container, options) => container.append(this.splitCamelCase(options.data.stato) || ''),
        },
        {
          dataField: 'data_creazione',
          caption: 'Data',
          dataType: 'date',
          width: 90,
          alignment: 'center',
          allowSorting: false,
        },
        {
          dataField: 'numero_fir',
          caption: 'Numero Fir',
          dataType: 'string',
          width: 130,
          allowSorting: false,
        },
        {
          dataField: 'produttore',
          caption: 'Produttore',
          dataType: 'string',
          allowSorting: false,
          cellTemplate: (container, options) => container.append(options.data.produttore.denominazione || '')
        },
        {
          dataField: 'trasportatori',
          caption: 'Trasportatore',
          dataType: 'string',
          allowSorting: false,
          cellTemplate: (container, options) => container.append(options.data.trasportatori[0].denominazione || '')
        },
        {
          dataField: 'destinatari',
          caption: 'Destinatario',
          dataType: 'string',
          allowSorting: false,
          cellTemplate: (container, options) => container.append(options.data.destinatari[0].denominazione || '')
        },
        {
          dataField: 'codice_eer',
          caption: 'EER',
          dataType: 'string',
          alignment: 'center',
          width: 90,
          allowSorting: false,
        },
        {
          dataField: 'quantita',
          caption: 'Quantità',
          dataType: 'string',
          alignment: 'center',
          width: 90,
          allowSorting: false,
        },
      ];
    }
    this.Cdr.detectChanges()
  }

  private processSessionStorage(input: Partial<FirStore>) {
    let data: Partial<FirStore> = this.getSessionStorage()
    if (!data) data = {};

    Object.keys(input).forEach((key) => {
      data[key] = input[key]
    })
    return sessionStorage.setItem(this.KEY_STORE, JSON.stringify(data))
  }
  private getSessionStorage(): FirStore | null {
    if (sessionStorage.getItem(this.KEY_STORE)) {
      return JSON.parse(sessionStorage.getItem(this.KEY_STORE))
    } else return null
  }

  async apriLista(row) {
    if (!row || !row.data || !row.data.numero_fir) return;
    const numero_fir = row.data.numero_fir
    if (!numero_fir) return;
    const soggetto = await this.Apiservice.GetApi(`soggetto/${this.soggettoSelected}`) as Record<any, string>
    const firRemoto: FirRemoto = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}?idSoggetto=${this.soggettoSelected}`) as FirRemoto
    const guid = uuidv1()
    const instanceData = {
      soggetto,
      firRemoto,
      guid
    }
    this.ComponentService.setNewPopUp(guid, 'ListaAllegatiAnnotazioniComponent', null, '900', null, instanceData, false, true, `Lista Allegati Fir: ` + numero_fir)
    this.ComponentService.outputComponent.subscribe((out) => {
      if (out.guid === guid) {

      }
    })
  }
}
